import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function setSentryUser(user: { uuid: string; email: string } | null) {
  if (user) {
    Sentry.setUser({ id: user.uuid, email: user.email });
  } else {
    Sentry.setUser(null);
  }
}

export function setSentryGroup(group: { uuid: string; name: string } | null) {
  Sentry.setTag("group.uuid", group?.uuid ?? null);
  Sentry.setTag("group.name", group?.name ?? null);
}
